__webpack_require__.p = "/ski-resorts/";